import {
    GET_ERRORS
} from './type';
import Products from '../Models/Products';

export const sellerRequest = (sellerData, history) => dispatch => {
    // let i=[];
    Products.saveRequest(sellerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                alert('リクエストありがとうございます！提案があると通知されます。')
                history.push('/seller-buyer-request-home');
            }
            else {
                dispatch({
                    type: GET_ERRORS,
                    payload: 'データを取得できませんでした！ 後で試してください'
                })
            }

        })
        .catch()
};